import React from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Upload, Modal } from "antd";

import axios from "axios";
import shortid from "shortid";

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

class PicturesWall extends React.Component {
  componentDidMount() {
    axios
      .get("https://wavecode-backend.herokuapp.com/api/qr/static", {
        headers: { Authorization: this.token },
      })
      .then(({ data: { data } }) => {
        const newData = data.map((d) => {
          return {
            uid: shortid(),
            name: d,
            url: d,
            status: "done",
          };
        });
        console.log(newData);
        this.setState({ fileList: [...this.state.fileList, newData] });
      })
      .catch((err) => {
        const error = new Error("Some error");
        console.error(error);
      });
  }
  state = {
    previewVisible: false,
    previewImage: "",
    previewTitle: "",
    fileList: [
      //   {
      //     uid: "-1",
      //     name: "image.png",
      //     status: "done",
      //     url: "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
      //   },
      //   {
      //     uid: "-2",
      //     name: "image.png",
      //     status: "done",
      //     url: "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
      //   },
      //   {
      //     uid: "-3",
      //     name: "image.png",
      //     status: "done",
      //     url: "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
      //   },
      //   {
      //     uid: "-xxx",
      //     percent: 50,
      //     name: "image.png",
      //     linkProps: { download: "image" },
      //     status: "done   ",
      //     url: "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
      //   },
      //   {
      //     uid: "-5",
      //     name: "image.png",
      //     status: "done",
      //   },
    ],
  };

  handleCancel = () => this.setState({ previewVisible: false });

  handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
      previewTitle:
        file.name || file.url.substring(file.url.lastIndexOf("/") + 1),
    });
  };

  handleChange = ({ fileList }) => this.setState({ fileList });
  //   onChange = (e) => {
  //     console.log(e.target.files[0]);
  //     let formData = new FormData();

  //     formData.append("bgImage", e.file);
  //     request
  //       .post("qr/images", formData, {
  //         headers: { Authorization: token, "Access-Control-Allow-Origin": "*" },
  //       })
  //       .then((data) => console.log(data))
  //       .catch((err) => err.response);
  //   };
  token =
    "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2MjEzNmIxZjlhYjQ2ZTExY2RlMDc2N2MiLCJmdWxsTmFtZSI6InN1YiB1c2VyIiwiZW1haWwiOiJzdWJ1c2VyQHRlc3QuY29tIiwicGFzc3dvcmQiOiIkMmIkMTAkVTRKNFJIak5xR2QyMGgzWGwyQ3BDdVF4T1VJL2QuTnZMZWFyUjIvZUtvY2p6R0Jwa0xkcHUiLCJyb2xlIjoic3VidXNlciIsImNyZWF0ZWRCeSI6IjYyMTE1MDYwYzZmZDExYTk1NTZjYTNjOCIsInFyQWxsb3dlZCI6MTUsInN1YnVzZXJBbGxvd2VkIjowLCJjcmVhdGVkQXQiOiIyMDIyLTAyLTIxVDEwOjM2OjE1Ljg4MVoiLCJ1cGRhdGVkQXQiOiIyMDIyLTAyLTIyVDEyOjA5OjQxLjg5N1oiLCJfX3YiOjAsInFyVW51c2VkIjoxMiwiaWF0IjoxNjQ1Njg0MTI5LCJleHAiOjE2NDgyNzYxMjl9.hVbGOZNrUqnaDD8YIoIo6ReRUcdikh0Cz9dYXmYON2c";

  uploadImage = (options) => {
    const { onSuccess, onError, file, onProgress } = options;

    const fmData = new FormData();
    const config = {
      headers: {
        "content-type": "multipart/form-data",
        Authorization: this.token,
      },
      onUploadProgress: (event) => {
        console.log((event.loaded / event.total) * 100);
        onProgress({ percent: (event.loaded / event.total) * 100 }, file);
      },
    };
    fmData.append("bgImage", file);
    axios
      .post("http://localhost:8080/api/qr/images", fmData, config)
      .then((res) => {
        onSuccess(file);
        console.log(res);
      })
      .catch((err) => {
        const error = new Error("Some error");
        onError({ event: error });
      });
  };
  render() {
    const { previewVisible, previewImage, fileList, previewTitle } = this.state;
    const uploadButton = (
      <div>
        <PlusOutlined />
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    );
    return (
      <>
        <Upload
          customRequest={this.uploadImage}
          listType="picture-card"
          fileList={fileList}
          onPreview={this.handlePreview}
          onChange={this.handleChange}
          //   beforeUpload={(file) => {
          //     console.log(file);
          //     return true
          //   }}
        >
          {fileList.length >= 25 ? null : uploadButton}
        </Upload>
        <Modal
          visible={previewVisible}
          title={previewTitle}
          footer={null}
          onCancel={this.handleCancel}
        >
          <img alt="example" style={{ width: "100%" }} src={previewImage} />
        </Modal>
      </>
    );
  }
}
export default PicturesWall;
